<template>
    <el-dialog
            visible
            width="65%"
            @close="onCancel">
            <div slot="title">
                <span class="font18">{{ initData.id? $t('COMMON_EDIT') : $t('COMMON_ADD') }}</span>
            </div>
            <el-form ref="form" :model="form" label-width="140px" >
                <template v-if="active==='1' || active==='4'">
                    <el-form-item :label="$t('newsMgt.newsTitle')" :rules="validateTip"  prop="newsTitle">
                        <el-input v-model="form.newsTitle" maxlength="100" show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.newsDesc')" :rules="validateTip" prop="newsDesc">
                        <el-input v-model="form.newsDesc" type="textarea" maxlength="500" show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.linkText')" :rules="validateTip" prop="linkText">
                        <el-input v-model="form.linkText" maxlength="100" show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.linkUrl')" :rules="validateTip" prop="linkUrl">
                        <el-input v-model="form.linkUrl" type="textarea" maxlength="500" show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.newsOrder')" :rules="validateTip" prop="newsOrder">
                        <el-input-number v-model="form.newsOrder" controls-position="right" :min="0" ></el-input-number>
                    </el-form-item>
                </template>
                <template v-if="active==='2'">
                    <el-form-item :label="$t('newsMgt.docCategory')" :rules="validateTip" prop="docCategory">
                        <el-input v-model="form.docCategory" disabled ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.docCatalog')" :rules="validateTip" prop="docCatalog">
                        <el-input v-model="form.docCatalog" maxlength="50" show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.docName')" :rules="validateTip" prop="docName">
                        <el-input v-model="form.docName" maxlength="100" show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.hyperlink')" :rules="validateTip" prop="hyperlink">
                        <el-input v-model="form.hyperlink" type="textarea" maxlength="500" show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.docOrder')" :rules="validateTip" prop="docOrder">
                        <el-input-number v-model="form.docOrder" controls-position="right" :min="0" ></el-input-number>
                    </el-form-item>
                </template>
                <template v-if="active==='3'">
                    <el-form-item :label="$t('newsMgt.materialTitle')" :rules="validateTip" prop="materialTitle">
                        <el-input v-model="form.materialTitle" maxlength="100" show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.materialCategory')" :rules="validateTip" prop="materialCategory">
                        <el-input v-model="form.materialCategory" disabled show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.linkUrl')" :rules="validateTip" prop="linkUrl">
                        <el-input v-model="form.linkUrl" type="textarea" maxlength="500" show-word-limit ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('newsMgt.materialOrder')" :rules="validateTip" prop="materialOrder">
                        <el-input-number v-model="form.materialOrder" controls-position="right" :min="0" ></el-input-number>
                    </el-form-item>
                </template>
        </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="onCancel"
                           class="cancel-btn">{{$t('comment_reSet')}}</el-button>
                <el-button type="primary"
                           @click="onConfirm('form')"
                           class="wl-green">{{$t('btn_save')}}</el-button>
          </span>
    </el-dialog>
</template>

<script>
    import API from "@/api";
    import {mapGetters} from "vuex";
    import { deepClone } from '@/utils'
    
    export default {
        name: "NewsAdd",
        props: {
            initData: {
                type: Object,
                default: {}
            },
            onCancel: {
                type: Function,
                default: () => {}
            },
            onAdd: {
                type: Function,
                default: () => {}
            },
            active: {
                type: String,
                default:null
            },
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getSite: 'getSite',
            }),
        },
        watch: {
            
        },
        data(){
            return {
                form:{},
                validateTip:{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }
            }
        },
      
        mounted() {
            this.form = deepClone(this.initData)
            if(this.active === '2'){
                this.form.docCategory = 'Communicate with your client'
            }
            if(this.active === '3'){
                this.form.materialCategory = 'For KPMG Team'
            }
        },
        methods: {
            onConfirm(formName) {
                console.log(this.$refs[formName]);
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.onAdd(this.form)
                } else {
                    return false;
                }
                });
            },
        }
    }
</script>

<style scoped>
    .font18{
        font-size: 18px;
    }
    .select-width{
        width: 100%;
    }
    .entity-list-tree-node {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .entity-list-tree-node .extra-area {
        margin-right: 5px;
        color: #409eff;
        align-self: center;
    }
    .entity-list-tree-node .extra-area:hover {
        margin-right: 5px;
        color: #409eff;
    }
    .required-cls{
        color:#fd349c;
        font-size: 14px;
        margin-right: 5px;
    }
    .tree {
        margin-top: 10px;
        height: 250px;
        overflow-y: auto;
    }
</style>